import { ActionTypes } from '../../actions/settings/managers_index'
const {
  GET_MANAGERS,

} = ActionTypes

const initialState = {
  managers: [],
  customerId: '',
  customerLeagueId: '',
  urls: {},
}

const managers = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANAGERS: {
      return {
        ...state,
        managers: action.data.managers,
      }
    }
    default:
      return state
  }
}

export default managers
